var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayNumber)?_c('span',{staticClass:"precio-syb"},[_vm._v(_vm._s(_vm.miles(_vm.displayNumber)))]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }